module.exports = __webpack_public_path__ + "img/LogoIEPTB_BR_light.fd5a2563.png";